﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbMax,
    dependencies: [
    ]
})
export class KbMax extends Directive {
    constructor() {
        super();
        this.restrict = "A";
        this.require = "ngModel";
            
        this.link = (scope, elem, attr, ctrl) => {
            let maxValidator = value => {
                let max = scope.$eval(attr.ngMax) || Infinity;
                if (ctrl.$viewValue && ctrl.$viewValue > max) {
                $(elem).val(max);
                return max;
                }
                return value;
            };

            ctrl.$parsers.push(maxValidator);
            ctrl.$formatters.push(maxValidator);
        };
    }
}
